export default "__VITE_ASSET__B9aEF4kM__"